import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=10c0ecca&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style1 from "./Main.vue?vue&type=style&index=1&id=10c0ecca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c0ecca",
  null
  
)

export default component.exports